import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getRoleInfo } from '../../../store/actions';
import { getAdminState } from '../../../store/selectors';

class CurrentRole extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      roleInfo: {
        schools: null,
        districts: null,
      },
    };
  }

  componentDidMount = async () => {
    const { userProfileInfo } = this.props.admin;
    const roleInfo = await this.props.getRoleInfo(
      userProfileInfo.id,
      userProfileInfo.role,
      userProfileInfo.tenantId
    );
    this.setState({
      roleInfo,
    });
  };

  render() {
    const { roleInfo } = this.state;
    return (
      <div
        style={{
          border: '1px solid black',
          padding: '25px',
          marginTop: '25px',
        }}
      >
        <h1>Current Role:</h1>
        <br />
        <p>{this.props.admin?.userProfileInfo?.role}</p>
        <br />
        {roleInfo &&
          roleInfo?.schools?.length > 0 &&
          roleInfo?.schools?.map((school) => <div>{school.name}</div>)}
        {roleInfo &&
          roleInfo?.districts?.length > 0 &&
          roleInfo?.districts?.map((district) => <div>{district.name}</div>)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const admin = getAdminState(state);
  return { admin };
}

export default withRouter(
  connect(mapStateToProps, { getRoleInfo })(CurrentRole)
);
